import { Injectable, signal } from '@angular/core';

/**
 * Holds referral notices raised by route guards.
 *
 * Guards can run before the root component (and its toast outlet) exists,
 * so messages are queued here and flushed once the app has rendered.
 */
@Injectable({ providedIn: 'root' })
export class ReferralNoticeService {
  private readonly pendingErrorKey = signal<string | null>(null);

  /** Queues a translation key to be shown as an error toast. */
  queueError(translationKey: string): void {
    this.pendingErrorKey.set(translationKey);
  }

  /** Returns the queued translation key (if any) and clears it. */
  consumeError(): string | null {
    const key = this.pendingErrorKey();
    if (key) {
      this.pendingErrorKey.set(null);
    }
    return key;
  }
}
